<tr>
  <th *ngFor="let header of headers">
    <span *ngIf="header.sortable" [class]="'cursor-pointer fa ' + headerIcon(header.visibleName)" (click)="onSortChange(header)"></span>
    <span>{{ header.visibleName | translate }}</span>
  </th>
</tr>
